ixModuleRouting("impactx.contentservicebrowser", {
    "/contentservicebrowser": {
        templateUrl:
            "modules/contentservicebrowser/templates/filebrowserlist.html",
        controller: "ContentServiceBrowserListCtrl",
        controllerAs: "fileBrowserListCtrl",
        process: "ContentServiceBrowserView",
    },
    "/contentservicebrowser/:path": {
        templateUrl:
            "modules/contentservicebrowser/templates/filebrowserlist.html",
        controller: "ContentServiceBrowserListCtrl",
        controllerAs: "fileBrowserListCtrl",
        process: "ContentServiceBrowserView",
    },
});
